<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="col-lg-4 display-flex">
                <div class="col-lg-6 col-md-4 col-xs-4 pretty-input side-input-text">Empty Slots</div>
                <input type="number" v-model="filterIPs.emptySlotsFrom" min="0" name="" placeholder="From" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
                <input type="number" v-model="filterIPs.emptySlotsTo" min="0" name="" placeholder="To" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
            </div>
            <div class="col-lg-4 display-flex">
                <div class="col-lg-6 col-md-4 col-xs-4 pretty-input side-input-text">Max Slots</div>
                <input type="number" v-model="filterIPs.maxSlotsFrom" min="0" name="" placeholder="From" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
                <input type="number" v-model="filterIPs.maxSlotsTo" min="0" name="" placeholder="To" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
            </div>
            <div class="col-lg-4 display-flex">
                <div class="col-lg-6 col-md-4 col-xs-4 pretty-input side-input-text">Used Slots</div>
                <input type="number" v-model="filterIPs.usedSlotsFrom" min="0" name="" placeholder="From" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
                <input type="number" v-model="filterIPs.usedSlotsTo" min="0" name="" placeholder="To" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
            </div>
        </div>
        <div class="col-lg-12 m-t-sm">
            <div class="col-lg-4">
                <v-select placeholder="Client duplicates?"></v-select>
            </div>
            <div class="col-lg-4">
                <v-select placeholder="Has Clients?" :options="[{val: false, txt: 'No'}, {val: true, txt: 'Yes'}]"  label="txt" index="val" v-model="filterIPs.hasClients"></v-select>
            </div>
            <div class="col-lg-4">
                <v-select placeholder="Has PBNs?" :options="[{val: false, txt: 'No'}, {val: true, txt: 'Yes'}]"  label="txt" index="val" v-model="filterIPs.hasPbns"></v-select>
            </div>
        </div>
        <div class="col-lg-12 m-t-sm">
            <div class="col-lg-4">
                <table class="table  table-hover">
                    <thead>
                        <tr>
                            <th>IP</th>
                            <th>Location</th>
                            <th>Slots</th>
                            <th v-tooltip="'Used Slots'">Used</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ip, index) in filterIpTable" :key="index" :class="(ip.ip === ipToExpand.ip ? 'green-left-border' : '')">
                            <td>{{ ip.ip }}</td>
                            <td>{{ ip.data.city }}, {{ ip.data.country }}</td>
                            <td>{{ ip.slots }}</td>
                            <td>{{ ip.used }}</td>
                            <td>
                                <a @click="toggleIPinfo(ip.id)">
                                    <i v-if="ipToExpand.id === ip.id" class="fa-solid fa-arrow-left fa-lg" v-tooltip="'Hide IP info'"></i>
                                    <i v-else class="fa-solid fa-arrow-right fa-lg" v-tooltip="'Expand IP info'"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-lg-8">
                <table class="table table-stripped table-hover">
                    <thead>
                        <tr>
                            <th>IP Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ipEntry, index) in getIpToExpand" :key="index">
                            <td v-if="ipEntry[0] !== 'id' && (typeof ipEntry[1] !== 'object')">
                                <span class="col-lg-3"><strong>{{ ipEntry[0] }}</strong></span>
                                <span>{{ ipEntry[1] }}</span>
                            </td>
                            <td v-else-if="(typeof ipEntry[1] === 'object' )">
                                <span v-if="['clients','pbns'].includes(ipEntry[0])">
                                    <span class="col-lg-3"><strong>{{ipEntry[0]}}</strong></span>
                                    <span>{{ ipEntry[1].map(obj => obj.name).join(', ') }}</span>
                                </span>
                                <span v-else>
                                    <span class="col-lg-3"><strong>{{ipEntry[0]}}</strong></span>
                                    <span>{{ipEntry[1].city}}, {{ipEntry[1].country}}</span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  data () {
    return {
      filterIPs: {
        hasClients: null,
        hasPbns: null
      },
      ipMockData: [
        {
          'ip': '188.241.114.106',
          'id': '29aacba3-1607-457c-8804-dc4ec9933228',
          'slots': 3,
          'used': 2,
          'freeSlots': 1,
          'data': {
            'city': 'Bucharest',
            'country': 'Romania',
            'country_code': 'RO',
            'signature': 'nginx/1.4.4'
          },
          'clients': [
            {
              '$oid': '5f91319bced39178dcb0600e',
              'name': 'brkouksh'
            },
            {
              '$oid': '62664d5c40e4830f8670dafa',
              'name': 'very nice client'
            }
          ],
          'pbns': [
            {
              '$oid': '5f914c98ced39178dcb062a2',
              'name': 'pretty pbn'
            },
            {
              '$oid': '5f914ccdced39178dcb065ef',
              'name': 'lambda'
            },
            {
              '$oid': '62ac52d463ec87c4b91cc937',
              'name': 'teta'
            }
          ]
        },
        {
          'ip': '77.81.240.141',
          'id': '281f9fc4-2442-4505-a9ba-e988def11e35',
          'slots': 3,
          'used': 3,
          'freeSlots': 0,
          'data': {
            'city': 'Amsterdam',
            'country': 'Netherlands',
            'country_code': 'NL',
            'signature': 'Apache/2.4.10 (Unix) OpenSSL/1.0.1e-fips mod_bwlimited/1.4 mod_fcgid/2.3.9 mod_jk/1.2.40'
          },
          'clients': [
            {
              '$oid': '5f91319bced39178dcb0600e',
              'name': 'client 1 name'
            },
            {
              '$oid': '62664d5c40e4830f8670dafa',
              'name': 'client 2 name'
            }
          ],
          'pbns': [
            {
              '$oid': '5f914c98ced39178dcb06295',
              'name': 'pbn 1 name'
            },
            {
              '$oid': '5f914ca9ced39178dcb063b4',
              'name': 'pbn 2 name'
            },
            {
              '$oid': '62ac52cf63ec87c4b91cc7f2',
              'name': 'pbn 3 name'
            }
          ]
        },
        {
          'ip': '188.241.114.240',
          'id': '29aacba3-1607-457c-8804-dc4ec9933226',
          'slots': 3,
          'used': 0,
          'freeSlots': 3,
          'data': {
            'city': 'Bucharest',
            'country': 'Romania',
            'country_code': 'RO',
            'signature': 'nginx/1.4.4'
          },
          'clients': [
            {
              '$oid': '5f91319bced39178dcb0600e',
              'name': 'client1'
            },
            {
              '$oid': '62664d5c40e4830f8670dafa',
              'name': 'client2 has a very long name'
            }
          ],
          'pbns': [
            {
              '$oid': '5f914c98ced39178dcb062a2',
              'name': 'pbn 1'
            },
            {
              '$oid': '5f914ccdced39178dcb065ef',
              'name': 'pbn 2'
            },
            {
              '$oid': '62ac52d463ec87c4b91cc937',
              'name': 'pbn 3'
            }
          ]
        },
        {
          'ip': '188.241.114.356',
          'id': '29aacba3-1607-457c-8804-dc4ec9933266',
          'slots': 3,
          'used': 2,
          'freeSlots': 1,
          'data': {
            'city': 'Red rock',
            'country': 'Asgardia',
            'country_code': 'AS',
            'signature': 'nginx/1.4.4'
          },
          'clients': [
          ],
          'pbns': [
            {
              '$oid': '5f914c98ced39178dcb062a2',
              'name': 'pretty pbn'
            },
            {
              '$oid': '5f914ccdced39178dcb065ef',
              'name': 'lambda'
            },
            {
              '$oid': '62ac52d463ec87c4b91cc937',
              'name': 'teta'
            }
          ]
        }
      ],
      ipToExpand: {}
    }
  },
  mounted () {
    // this.loadIPs()
  },
  methods: {
    toggleIPinfo (ipId) {
      if (this.ipToExpand.id === ipId) {
        this.ipToExpand = {}
        return
      }
      this.ipToExpand = this.ipMockData.filter(ip => ip.id === ipId)[0]
    }
    /*
    showInternalLinks (id) {
      $('#internalLinks-' + id).css('display', this.showInternal[id] ? 'none' : 'block')
      this.showInternal[id] = !this.showInternal[id]
    },
    uniqueLinkDomains (externalLink) {
      if (externalLink === undefined) { return }
      let domainList = externalLink.map(l => l.linkDomain)
      let uniqueLinks = {}
      for (let domain of domainList) {
        uniqueLinks[domain] === undefined ? uniqueLinks[domain] = 1 : uniqueLinks[domain] += 1
      }
      return uniqueLinks
    },
    showLinkTags (postId, externalLinkUrl) {
      let tag = this.links.filter(l => l.post.id === postId && l.url.includes(externalLinkUrl)).map(l => l.tag.tags.filter(v => v !== 'unknown')).join()
      return tag
    },
    showPostLinks (postId) {
      this.filterLinks.postId = this.filterLinks.postId === postId ? null : postId
    },
    showIcon (postId) {
      return this.filterLinks.postId !== postId
    },
    showPostTag (postId) {
      let tagList = this.links.filter(l => l.post.id === postId).map(t => t.tag.tags)
      let mergedTagList = [].concat.apply([], tagList)
      let uniqueTags = [...new Set(mergedTagList.filter(v => v !== 'unknown'))]
      return uniqueTags
    },
    showIndexedLinks () {
      this.filterLinks['indexed'] === true ? this.filterIPs['externalLinks'] = true : this.filterIPs['externalLinks'] = this.filterIPs['externalLinks']
    } */
  },
  computed: {
    getIpToExpand () {
      return Object.entries(this.ipToExpand)
    },
    filterIpTable () {
      let newIpLists = this.ipMockData
      // has clients
      if (this.filterIPs.hasClients !== null) {
        newIpLists = this.filterIPs.hasClients === true ? newIpLists.filter(ip => ip.clients.length > 0) : newIpLists.filter(ip => ip.clients.length === 0)
      }
      // has pbns
      if (this.filterIPs.hasPbns !== null) {
        newIpLists = this.filterIPs.hasPbns === true ? newIpLists.filter(ip => ip.pbns.length > 0) : newIpLists.filter(ip => ip.pbns.length === 0)
      }
      // empty slots || free slots
      if (this.filterIPs.emptySlotsFrom) {
        newIpLists = newIpLists.filter(ip => this.filterIPs.emptySlotsFrom <= ip.freeSlots)
      }
      if (this.filterIPs.emptySlotsTo) {
        newIpLists = newIpLists.filter(ip => ip.freeSlots <= this.filterIPs.emptySlotsTo)
      }

      // max slots
      if (this.filterIPs.maxSlotsFrom) {
        newIpLists = newIpLists.filter(ip => ip.slots >= this.filterIPs.maxSlotsFrom)
      }
      if (this.filterIPs.maxSlotsTo) {
        newIpLists = newIpLists.filter(ip => ip.slots <= this.filterIPs.maxSlotsTo)
      }

      // used slots
      if (this.filterIPs.usedSlotsFrom) {
        newIpLists = newIpLists.filter(ip => ip.used >= this.filterIPs.usedSlotsFrom)
      }
      if (this.filterIPs.usedSlotsTo) {
        newIpLists = newIpLists.filter(ip => ip.used <= this.filterIPs.usedSlotsTo)
      }

      return newIpLists
    }
  }
}
</script>
<style scoped>
.green-left-border {
  border-left: 5px solid #18a689;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/IPOverview/IPTabs/Ips.vue